import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";
import { IdentityVerificationDocumentTypes } from "../domain/IdentityVerificationDocumentTypes";

export const IdentityVerificationDocumentTypeInformation: {
  [key in IdentityVerificationDocumentTypes]: { icon: JSX.Element; label: string };
} = {
  [IdentityVerificationDocumentTypes.ID_CARD]: {
    icon: ICON_PATHS.ID_CARD_CLIP,
    label: "widget.document_types.id_card",
  },
  [IdentityVerificationDocumentTypes.DRIVER_LICENSE]: {
    icon: ICON_PATHS.CAR,
    label: "widget.document_types.driver_license",
  },
  [IdentityVerificationDocumentTypes.PASSPORT]: {
    icon: ICON_PATHS.PASSPORT,
    label: "widget.document_types.passport",
  },
  [IdentityVerificationDocumentTypes.RESIDENCE_PERMIT]: {
    icon: ICON_PATHS.ADDRESS_CARD,
    label: "widget.document_types.residence_permit",
  },
};
